function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 0C8.50725 0 0 8.50725 0 19C0 29.4928 8.50725 38 19 38C29.4928 38 38 29.4928 38 19C38 8.50725 29.4928 0 19 0ZM28.5 20.5833H20.5833V28.5C20.5833 29.3756 19.874 30.0833 19 30.0833C18.126 30.0833 17.4167 29.3756 17.4167 28.5V20.5833H9.5C8.626 20.5833 7.91667 19.8756 7.91667 19C7.91667 18.1244 8.626 17.4167 9.5 17.4167H17.4167V9.5C17.4167 8.62442 18.126 7.91667 19 7.91667C19.874 7.91667 20.5833 8.62442 20.5833 9.5V17.4167H28.5C29.374 17.4167 30.0833 18.1244 30.0833 19C30.0833 19.8756 29.374 20.5833 28.5 20.5833Z",
  fill: "#CDD0D7"
});

var SvgEmptyAddContent = function SvgEmptyAddContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyAddContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_add_content.54384470.svg";
export { ForwardRef as ReactComponent };